  $(document).ready(function(){
  
  let $body = $('body'),
      gift_note_thumb = 'https://cdn.shopify.com/s/files/1/0638/0119/6793/files/amd-gift-note-card-thumb.png?v=1656494651';
  window.bundle_modal = new theme.Modals('BundleRequired', 'bundle-required', {
    closeOffContentClick: false,
    bodyOpenClass: ['modal-open', 'bundle-modal-open'],
    solid: true
  });
  
  window.note_modal = new theme.Modals('NoteRequired', 'note-required', {
    closeOffContentClick: false,
    bodyOpenClass: ['modal-open', 'bundle-modal-open'],
    solid: true
  });
  
  $( "#datepicker" ).datepicker();
  
  /*************************Function Declarations*************************/
  var char_limit = parseInt($('.remaining-characters-text').attr('data-char-limit'));
  $("#boxNote").keyup(function(){
        $(".remaining-characters-text i").text("Characters remaining: " + (char_limit - $(this).val().length));
    });
  function setupKey() {
    var s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array(32).join().split(',').map(function() { return s.charAt(Math.floor(Math.random() * s.length)); }).join('');
  }
  let getCurrentlySelectedProducts = () => {
    return currentlySelected = $('.bundle-step-wrapper:visible .grid-product.selected')
  }
  let getSelectedCards = () => {
    return $('.build-a-bundle-page .grid-product.selected')
  }
  let getCurrentStepSelectedCards = () => {
    let selectedProducts = $('.build-a-bundle-page .bundle-step-wrapper:visible .grid-product.selected')
    let selectedArray = []
  
    $(selectedProducts).each((k, product) => {
      let step = $(product).closest('.bundle-step-wrapper').data('step'),
          prd_qty = parseInt($(product).attr('data-qty'));
      selectedArray.push({ step: step, product: product,qty: prd_qty})
    })
    return selectedArray;
  }
  let getActiveStepContainer = () => {
    return $('.bundle-step-wrapper:visible')
  }
  let getActiveStep = () => {
    return $('.bundle-step-wrapper.active-step')
  }
  
  let setProductImages = () => {
    let selectedProducts = getSelectedCards();
    $('[data-choosen-products]').empty();
    $(selectedProducts).each((k, product) => {
      var imgs='';
      let step = $(product).closest('.bundle-step-wrapper').data('step');
      var grid_step = $(`.grid-item[data-step=${step}] [data-choosen-products]`);
      var qty_added = parseInt($(product).attr('data-qty'));
      imgs = `<li><img src="${$(product).attr('data-img')}" alt="${$(product).attr('data-title')}"/><span class="BuildSummary__quantity-added">${qty_added}</span></li>`;
      grid_step.append(imgs);
    })
  }
  
  let toggleSelection = (product) => {
    var current_step_no = parseInt(getActiveStep().attr('data-step'));
    var grid_step = $(`.grid-item[data-step=${current_step_no}] [data-choosen-products]`);
    var grid_action = product.find('.grid-product__actions');
    if (!$(product).hasClass('selected')) {
      let selectedProducts = getCurrentlySelectedProducts()
      let selectionLimit = Number(getActiveStepContainer().data('limit'))
      if (selectionLimit == 0 || selectedProducts.length < selectionLimit) {
        $(product).addClass('selected')
        $(product).find('.product-card-button.remove').css({'display':'block'});
        $(product).find('.product-card-button.add').hide();
        if(current_step_no==2){
          if(grid_action){grid_action.addClass('active-qty')}
        }
      }
    }
    else {
      $(product).removeClass('selected')
      $(product).find('.product-card-button.add').css({'display':'block'})
      $(product).find('.product-card-button.remove').hide()
  //       $(product).next('.micromodal-slide').find('.product-card-button.remove').hide()
  //       $(product).next('.micromodal-slide').find('.product-card-button.add').css({'display':'block'})
      grid_step.empty();
      if(grid_action){grid_action.removeClass('active-qty')}
      removeProduct($(product).data('id'))
    }
  }
  let handleSelection = () => {
    let selectedProducts = getSelectedCards()
  
    let selectedArray = []
  
    $(selectedProducts).each((k, product) => {
      let step = $(product).closest('.bundle-step-wrapper').data('step')
      selectedArray.push({ step: step, product: product,qty:$(product).attr('data-qty') })
    })
    return selectedArray;
  }
  
  let getProducts = () => {
    return JSON.parse(localStorage.getItem('box-products'));
  }
  
  let clearProducts = () => {
    if (localStorage.setItem('box-products', '[]')) {
      return true
    }
  }
  
  let getCurrentStepProducts = () =>{
    return $('.build-a-bundle-page .bundle-step-wrapper:visible .grid-product');
  }
  
  function radioSort(el) {
    var radio_value;
    radio_value= el;
    
    var product_grid = getActiveStep().find('.product-grid');
    // console.log(radio_value)
    if (radio_value == "number-asc") {
      var divList = getCurrentStepProducts();
      divList.sort(function(a, b) {
        const contentA = parseInt($(a).data('number'));
        const contentB = parseInt($(b).data('number'));
        console.log(contentA,contentB)
        return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
      });
      product_grid.html(divList);
    }
    else if (radio_value == "number-desc") {
      var divList = getCurrentStepProducts();
      divList.sort(function(a, b) {
        const contentA = parseInt($(a).data('number'));
        const contentB = parseInt($(b).data('number'));
        console.log(contentA,contentB)
        return (contentA > contentB) ? -1 : (contentA < contentB) ? 1 : 0;
      });
      product_grid.html(divList);
    }
    else if (radio_value== "ascending") {
      var divList = getCurrentStepProducts();
      divList.sort(function(a, b){
        return String.prototype.localeCompare.call($(a).data('name').toLowerCase(), $(b).data('name').toLowerCase());
      });
      product_grid.html(divList);
    } else if (radio_value  == "descending") {
      var divList = getCurrentStepProducts();
      divList.sort(function(a, b){
        return String.prototype.localeCompare.call($(b).data('name').toLowerCase(),$(a).data('name').toLowerCase());
      });
      product_grid.html(divList);
    }
    else {
      var divList = getCurrentStepProducts();
      divList.sort(function(a, b) {
        const contentA = parseInt($(a).data('index'));
        const contentB = parseInt($(b).data('index'));
        console.log(contentA,contentB)
        return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
      });
      product_grid.html(divList);
    }
  }
  
  let addProduct = (productId, productQty, productTitle, productPrice, productType, productTags,productImage,searchId=null,update=false) => {
    var d = getProducts();
    if(getProducts() == null){
      var d=[];
    }
    let products = d;
    
    let duplicateItem = false;
  
    try {
      // check for duplicates before adding
      for (var item of products) {
        if (item.productId == productId) {
          duplicateItem = true;
          item.productQty = productQty;
        }
      }
      
  //       if(update==true && (searchId != null || searchId != undefined)){
  //         let find_pro = products.findIndex(element => element.productId == searchId);
  //         if(find_pro && duplicateItem){
  //           var temp_arr = products.slice(0,find_pro);
  //           console.log(temp_arr)
  //           duplicateItem = false;
  //           products = temp_arr;
  //         }
  //       }

      var container_box = $('.zero-step-wrapper .grid-product.selected');
      if (!duplicateItem) {
        //         console.log(products,productQty)
        products.push({
          productId: productId,
          productQty: productQty,
          productType: productType,
          productTags: productTags,
          productTitle: productTitle,
          productPrice: parseInt(productPrice),
          productImage: productImage,
          properties: {
            bundle_name:container_box.attr('data-title'),
            bundle_img:container_box.attr('data-img-large'),
          }
        });
      }
      writeProducts(products);
  //       console.log(products)
      return true;
    } catch (error) {
      throw error
    }
  }
  // adds duplicate to cart if adding more than one item at one step
  let writeProducts = (products) => {
    try {
      localStorage.setItem('box-products', JSON.stringify(products))
      return true
    } catch (error) {
      throw error
    }
  }
  let removeProduct = (productId) => {
    let products = getProducts();
  
    try {
      for (index in products) {
        if (products[index].productId == productId) {
          products.splice(index, 1);
        }
      }
  
      writeProducts(products)
      return true
    } catch (error) {
      throw error
    }
  }
  
  let prepare_summary = () => {
    var bundle_item = `<div class="cart__item">
   <div class="item cf midnight-thunder">
      <div class="image bundle_prod_image">
         <div class="bundle_image"><a href="javascript:;" class="js-no-transition">
            <img src="{{bundle_image}}" title="{{bundle_title}}">
            </a>
         </div>
         <div class="bundle_title medium-up--hide">
            <a class="name js-no-transition" href="javascript:;">{{bundle_title}}</a>
         </div>
      </div>
      <div class="bundle_wrapper">
         <div class="prise-detail">
            <a class="name js-no-transition small--hide" href="javascript:;">{{bundle_title}}</a>          
            <div class="sleeve_wrapper"><span class="ele-title">Your Sleeve: </span></div>
            <div class="sleeve_wrapper">{{sleeve_items}}</div>
            <div class="subitems_wrapper"><span class="ele-title">Your Selected Products: </span></div>
            <div class="subitems_wrapper">{{bundle_items}}</div>
            <div class="additional_items"><span class="ele-title">Gift Note and Recipient Details: </span></div>
            <div class="additional_items">{{additional_items}}</div>
            <div class="bundle_wrapper_bottom">
               <div class="bundle-remove"><a href="javascript:;" data-ids="{{bundle_item_ids}}" class="js-no-transition">Remove</a></div>
               <div class="bundle_price"><span class="product__price"><span>{{bundle_price}}</span></span></div>
            </div>
         </div>
      </div>
   </div>
</div>`;
    var container_product = `<div class="subitem container_product-item">
     <div class="product-img">
          <img src="{{item_img}}">
     </div>
      <span class="item_title">{{item_title}}</span>
      <span class="qty">{{item_qty}}</span>
    </div>`;
    var bundle_product = `<div class="subitem">
     <div class="product-img">
          <img src="{{item_img}}">
     </div>
      <span class="item_title">{{item_title}}</span>
      <span class="qty">{{item_qty}}</span>
    </div>`;
    var sleeve_product = `<div class="sleeve-subitem">
     <div class="product-img">
          <img src="{{item_img}}">
     </div>
      <span class="item_title">{{item_title}}</span>
      <span class="qty">{{item_qty}}</span>
    </div>`;

    var notes_ele = `<div class="additional-notes">
     <div class="gift-note">
          <div class="gift-note-title">Your Message: {{gift_note}}</div>
          <div class="from_user">From: {{from_user}}</div>
     </div>
    </div>`;
    var notes_ele2 = `<div class="additional-notes">
    <div class="shipping-date">
      <span class="delivery_date">Delivery Date: {{delivery_date}}</span>
      </div></div>`;
    
    let container_box = getProducts().filter(ele=>ele.productType == 'container box' && ele.productType != 'sleeve');
    let products = getProducts().filter(ele=>ele.productType != 'container box' && ele.productType != 'sleeve');
    let bundle_price = getProducts().reduce((a,b)=>a+b.productPrice,0);
    let sleeves = getProducts().filter(ele=>ele.productType == 'sleeve');
    var box_html='',
        item_html='',
      sleeve_html='';
   
    
    // console.log(container_product_final)

    for(var item of container_box){
       var container_product_final = bundle_item.replaceAll('{{bundle_title}}',item.productTitle)
      .replaceAll('{{bundle_image}}',item.productImage)
      .replaceAll('{{bundle_price}}',theme.Currency.formatMoney(bundle_price, theme.settings.moneyFormat));
      box_html += container_product_final;
      for(var sleev of sleeves){
        var temp_sl = sleeve_product.replaceAll('{{item_img}}',sleev.productImage.replace('_large','_100x'))
        .replaceAll('{{item_title}}',sleev.productTitle)
        .replaceAll('{{item_qty}}',sleev.productQty);
        sleeve_html += temp_sl;
      }
      for (var prod of products) {
          var final_item = bundle_product
          .replaceAll('{{item_img}}',prod.productImage.replace('_large','_100x'))
          .replaceAll('{{item_title}}',prod.productTitle)
          .replaceAll('{{item_qty}}',prod.productQty);
          item_html+=final_item;
        }
    }

    
    // for(var sleev of sleeves){
    //   var final_box = bundle_item
    //   .replaceAll('{{bundle_image}}',sleev.productImage)
    //   .replaceAll('{{bundle_title}}',container_box[0].productTitle + " "+sleev.productTitle)
    //   .replaceAll('{{bundle_price}}',theme.Currency.formatMoney(bundle_price, theme.settings.moneyFormat));
    //   box_html+=final_box;
    //   for (var item of products) {
    //     var final_item = bundle_product
    //     .replaceAll('{{item_img}}',item.productImage.replace('_large','_100x'))
    //     .replaceAll('{{item_title}}',item.productTitle)
    //     .replaceAll('{{item_qty}}',item.productQty);
    //     item_html+=final_item;
    //   }
    // }
    // item_html+=container_product_final;
    var notes_ele_final='';
    if($('#boxNote').val().length>0 && $('#from_field').val().length>0){
      notes_ele_final += notes_ele.replaceAll('{{gift_note}}',$('#boxNote').val()).replaceAll('{{from_user}}',$('#from_field').val());
    }
    if($('#datepicker').val().length>0){
      notes_ele_final+=notes_ele2.replaceAll('{{delivery_date}}',$('#datepicker').val());
    }
    
    
    box_html = box_html.replaceAll('{{bundle_items}}',item_html).replaceAll('{{sleeve_items}}',sleeve_html).replaceAll('{{additional_items}}',notes_ele_final);
    let activeStep = getActiveStep();
    let activeStepNo = Number($(activeStep).data('step'));
    activeStep.find('[data-box-summary-items]').empty().html(box_html);
    var stepper_no = $('.stepper-design .grid-item').eq((activeStepNo-1));
  //     stepper_no.addClass('active');
  }
  
  let populateStep = (searchId=null,isUpdate=false) => {
    let activeStep = getActiveStep();
    let activeStepNo = Number($(activeStep).data('step'));
    let selectedProducts = handleSelection();
    let step_prod_limit = parseInt($(activeStep).attr('data-limit'));
    let jar_limit = parseInt($(activeStep).attr('data-jar-limit')) || 0 ;
    let getCurrentStepProducts = getCurrentStepSelectedCards();
    let qty_selected = getCurrentStepProducts.reduce((qty,b)=>qty+b.qty,0);
  //     if(qty_selected<=step_prod_limit){
      getCurrentStepProducts.forEach((productObject) => {
        if (activeStepNo == productObject.step) {
                  // console.log(activeStepNo,productObject.product)
          addProduct($(productObject.product).data('id'),parseInt($(productObject.product).attr('data-qty')),$(productObject.product).data('title'),$(productObject.product).data('price'), $(productObject.product).data('type'), $(productObject.product).data('tags'),$(productObject.product).attr('data-img-large'),searchId,isUpdate)
        }
      })
  
  }
  let getTotalPrice = () => {
    let total = 0;
    let boxProducts = handleSelection()
    boxProducts.forEach((boxProduct) => {
  //       console.log(boxProduct.qty)
      total += parseInt($(boxProduct.product).data('price')) * parseInt(boxProduct.qty)
    })
    return total
  }
  
  let showPrice = () => {
    var total_price =(getTotalPrice() / 100).toFixed(2);
    let runningTotal = `${theme.Currency.formatMoney(total_price,theme.settings.moneyFormat)}`;
    $('[data-total-bundle-price]').empty().html(runningTotal)
  }
  let checkStepIndex = () => {
    let activeStep = getActiveStep();
    let nextStep = $(activeStep).next('.bundle-step-wrapper');
    let prevStep = $(activeStep).prev('.bundle-step-wrapper');
  
  
    if (nextStep.length == 0) {
      $('button#nextButton').hide();
      $('button.add-to-cart-btn').show()
      $('a.skip').css({'opacity': 0.5, 'pointer-events': 'none'});
    }
    else {
      $('button#nextButton').show();
      $('button.add-to-cart-btn').hide()
    }
    if (prevStep.length == 0) {
      $('#backButton').css({'opacity': 0.5, 'pointer-events': 'none'});
  
    }
    else {
      $('#backButton').css({'opacity': 1, 'pointer-events': 'auto'});
    }
  }
  let skipStep = (index) => {
    let activeStep = getActiveStep();
    let nextStep = null;
    let no = parseInt(activeStep.attr('data-step'));
  
    var stepper_no = $('.stepper-design .grid-item').eq(no);
    
    $('.stepper-design .grid-item').removeClass('active').removeClass('mobile-active');
  
    if(index < 0){
      nextStep = $(activeStep)
    }else{
      nextStep = $(activeStep).next('.bundle-step-wrapper:not(.active-step)');
    }
  
  
    if ($(nextStep).length > 0) {
      
      $(activeStep).removeClass('active-step');
      $(`.steps-images-wrapper .grid-item[data-step=${parseInt(activeStep.attr('data-step'))}]`).removeClass('mobile-active')
      $(activeStep).addClass('complete');
      $(nextStep).addClass('active-step');
      stepper_no.addClass('active').addClass('mobile-active')
      populateStep(null,false)
      
      if($(nextStep).hasClass('active-step')){
        $(`.steps-images-wrapper .grid-item[data-step=${parseInt(activeStep.attr('data-step'))+1}]`).addClass('mobile-active')
      }
    }
    
    checkStepIndex()
  }
  let previousStep = (index) => {
    let activeStep = getActiveStep();
    let prevStep = null;
    if(index < 0){
      prevStep = $(activeStep);
    }else{
      prevStep = $(activeStep).prev('.bundle-step-wrapper');
    }
  
    if ($(prevStep).length > 0) {
      $(activeStep).removeClass('active-step');
      $(prevStep).addClass('active-step');
      populateStep(null,false)
    }
    checkStepIndex()
  
  }
  
  let getAllSteps = () => {
    return $('.bundle-step-wrapper')
  }
  let getFilters = () => {
    return $('select.selectpicker,.btn-filter')
  }
  let toggleActiveCards = () => {
    let activeStep = getActiveStep();
    let stepStub = $(activeStep).data('step');
    let allSteps = getAllSteps();
    let allFilters = getFilters()
  
    $(allSteps).each((k, stepContainer) => {
      let stepValue = $(stepContainer).data('step');
  //       console.log(stepValue,stepStub)
      if (stepValue == stepStub) {
        $(stepContainer).addClass('active-step')
      }
      else {
        $(stepContainer).removeClass('active-step')
      }
    })
  
  
    $(allFilters).each((k, filter) => {
      let stepValue = $(filter).data('step');
  
      if (stepValue == stepStub) {
        $(filter).closest('.filter-container').show()
      }
      else {
        $(filter).closest('.filter-container').hide()
      }
    })
  
  //     toggleStepHeader()
  
    if (stepStub == 'write-a-note') {
      $('#shopify-section-box-testimonials,#shopify-section-box-collections').hide()
    }
    else {
      $('#shopify-section-box-testimonials,#shopify-section-box-collections').show()
  
    }
  
  }
  
  let checkIfRequired = () => {
    let activeStepContainer = getActiveStepContainer()
    let required = $(activeStepContainer).data('required')
    return required
  }
  let showSkip = (elem) => {
    if (!checkIfRequired()) {
      $('a.skip').css({'opacity': 1, 'pointer-events': 'auto'});
    }
    else {
      $('a.skip').css({'opacity': 0, 'pointer-events': 'none'});
    }
  }
  let validateNoteRequired = () =>{
    let currentActiveStep = getActiveStep();
    let currentStepStub = $(currentActiveStep).data('step');
    
    let note_required = $('#NoteRequired').data('note-required');
    let note_value = $.trim($("#boxNote").val());
    let isRequired = false;
    if(currentStepStub == '3' && note_value == "" && note_required == true){
      window.note_modal.open();
      // On next step load, go right to top   
  //       document.body.scrollTop = 0; // For Safari
  //       document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  //       $('body').css('overflowY', 'hidden'); 
      isRequired = true;
    }
    return isRequired;
  }
  
  $body.on('click','#note_yes_btn',function(){
    window.note_modal.close();
    skipStep()
    toggleActiveCards()
    checkStepIndex()
  })
  
  let manageProductSelectRequiredModal = (index) =>{
    if(index > 0){ //show
      window.bundle_modal.open();
      // On next step load, go right to top   
  //       document.body.scrollTop = 0; // For Safari
  //       document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  //       $('body').css('overflowY', 'hidden'); 
    }else{
      window.bundle_modal.close();
      //hide
      $('body').css('overflowY', 'auto'); 
    }
  }
  
  let addItemstoCart = () => {
    var bundle_type = "bundle-group-"+theme.current_page+":"+theme.date_time_now;
    let products = getProducts()
    let cart_count = parseInt($('#CartCount span:first-of-type').text())
    let boxID =  Math.random(0, 10000000)
  
    let boxType = 'custom';
    let boxValue = $('#boxNote').val();
  
    const currentPage = (window.location.pathname).split('/');
    const currentPath = currentPage.slice(-1);
  
    if(products.length == 1 ){
      let singleProduct = products[0];
      let currentTags = singleProduct.productTags;
    }
    const _gs_bundle_contents = [],
          _gs_bundle_discount=[],
          _gs_bundle_ids=[],
          _gs_bundle_quantities=[],
          _gs_bundle_prices=[];
    var gift_msg="";
    var itemData =[];
    products.forEach((product, pos) => {
      console.log(product.properties)
      const data = {
        id: product.productId,
        quantity:product.productQty,
        properties:{"bundle_type":bundle_type,'product_type':product.productType,'bundle_name':product.properties.bundle_name,'bundle_img':product.properties.bundle_img}
      }
      itemData.push(data)
    });
  
    const gift_note = $('#boxNote').val(),
          recipient = $.trim($('#from_field').val())
    
    /* Add 1 hidden bundle product like giftship is doing with required line items props*/
   
  
    console.log(itemData,gift_note,recipient)
     let formData = {
      'items': itemData
    };

    let cartAttributes = {};
    
    if($('#datepicker').val().length>0){
      cartAttributes.Delivery_Date = $('#datepicker').val()
  }
    if((gift_note.length>0 && recipient.length>0) && $('#datepicker').val().length>0 ){
        cartAttributes.Message = gift_note;
      cartAttributes.Recipient = recipient;
      cartAttributes.Delivery_Date = $('#datepicker').val()
    }

    console.log(cartAttributes)
  formData = {
      'items': itemData,
    attributes:cartAttributes
  };
   
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(res => res.json())
    .then(function(res){
      console.log(res)
      // window.location.href="/cart";
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    /*Ends script (Add 1 hidden bundle product like giftship is doing with required line items props)*/
  
    // console.log({ cart_count });
  
    // keep previous cart notes for multiple packages
    // const currentNote = CartJS.getNote();
    // let cartNote = `${currentNote} ${boxType} ${cart_count}: ${boxValue}`;
    // // console.log({ cartNote });
  
    if (currentPath != 'confetti-card') {
  //       CartJS.setNote(boxValue);
    }
    return true;
  }
  /*Function Declarations*/
  
  let skip = $('a.skip');
  let continueButton = $('#nextButton');
  let previous = $('#backButton')
  clearProducts();
  checkStepIndex();
  
  let productButton = $('.product-card-button');
  
  let cartCTAButton = $("#finishAddtoCart");
  cartCTAButton.on('click', (e) => {
    if (checkIfRequired()) {
      if (getCurrentlySelectedProducts().length == 0) {
        manageProductSelectRequiredModal(1);
        return false;
      }
    }
  
    let noteValidate = validateNoteRequired();
    if(noteValidate){
      return false;
    }
    e.preventDefault()
    let isAdded = addItemstoCart();
    if(isAdded) $(e.target).closest('button').text('Added to Cart').prop('disabled', true)
  })
  var current_step_no = parseInt(getActiveStep().attr('data-step'));
  var grid_step = $(`.grid-item[data-step=${current_step_no}] [data-choosen-products]`);

    
  $body.on('click','.product-card-button, .js-quick-add-bundle-item', (event) => {
    let product = $(event.target).closest('.grid-product')
    if (product.length == 0) {
      product = $(event.target).closest('.micromodal-slide').prev('.product-card')
    }

    var $product_counter = $('.product-counter');
     
    
    if(!isNaN(product.attr('data-limit'))){
      // console.log(product.attr('data-limit'))
      var limit = Number(product.attr('data-limit'));
      $('.js-product-selection').attr('data-limit',limit);
      $product_counter.find('.max-count').text(limit);
    }
    var action = $(event.target).closest('button').attr('data-action');
    var qty_ele = $(event.target).closest('.grid-product__actions').find('.Product__quantity-status');
    var qty = parseInt(qty_ele.text());
  //     console.log(qty_ele,qty)
    if(isNaN(qty) || qty==0){
      qty = 1;
    }
    qty_ele.text(qty);
    product.attr('data-qty',qty);
    
    toggleSelection(product)
    handleSelection()
    setProductImages();
    populateStep(null,false)
    showPrice()
    let activeStep = getActiveStep();
    $(activeStep).removeClass('complete');

    current_step_no = parseInt(getActiveStep().attr('data-step'));
    // console.log(current_step_no)
    if($(event.target).hasClass('js-toggle-select-box')){
      if(!$('[data-stepper]').hasClass('active-stepper')){
        $('[data-stepper]').addClass('active-stepper');
        var stepper_no = $('.stepper-design .grid-item').eq(0);
        $('#backButton').removeClass('disabled');
      }
      // console.log('hasClass',$(event.target).hasClass('add'))
    if((current_step_no==0 || current_step_no==1) && $(event.target).hasClass('add')){
      // console.log("current_step_no",current_step_no);
          continueButton.trigger('click');
      }
    }

     /*Qty restriction*/
    let step_prod_limit = parseInt($(activeStep).attr('data-limit'));
    let jar_limit = parseInt($(activeStep).attr('data-jar-limit')) || 0 ;
    let getCurrentStepProducts = getCurrentStepSelectedCards();
    let qty_selected = getCurrentStepProducts.reduce((qty,b)=>qty+b.qty,0);
    $product_counter.find('.current-count').text(qty_selected);
    $product_counter.find('.max-count').text(step_prod_limit);
    let selectedProducts = $('.build-a-bundle-page .bundle-step-wrapper:visible .grid-product');
      // console.log(qty_selected,step_prod_limit)
    if(qty_selected>=step_prod_limit){
      $(selectedProducts).each((k, product) => {
        $(product).find('button.js-quick-add-bundle-item').attr('disabled','disabled');
        $(product).find('button.Product__quantity-btn[data-action="plus"]').attr('disabled','disabled');
      })
    }
    else{
  //       console.log('ehre')
      $(selectedProducts).each((k, product) => {
        $(product).find('button.js-quick-add-bundle-item').removeAttr('disabled');
        $(product).find('button.Product__quantity-btn[data-action="plus"]').removeAttr('disabled');
      })
    }
    /*Qty restriction ends*/
    
    $('#nextButton').removeClass('disabled');
  
  })
  continueButton.on('click', (event) => {
    if (checkIfRequired()) {
      if (getCurrentlySelectedProducts().length == 0) {
        manageProductSelectRequiredModal(1);
        return false;
      }
    }
  
    let noteValidate = validateNoteRequired();
    if(noteValidate){
      return false;
    }
    
    let currentActiveStep = getActiveStep();
    let currentStepStub = $(currentActiveStep).data('step');
    if(currentStepStub==3){
      var grid_step = $(`.grid-item[data-step=${currentStepStub}] [data-choosen-products]`);
      var img = `<li><img src="${gift_note_thumb}" /></li>`;
      grid_step.empty().html(img);
    }
    skipStep()
    toggleActiveCards()
    showSkip(skip)
    checkStepIndex()
    // console.log(currentStepStub)
      if(currentStepStub==2){
              setTimeout(function() {
            $('#boxNote').val("")
            $('#boxNote').focus();
            }, 0);
        }
    if(currentStepStub==4){
      prepare_summary();
    }
  
  })
  $(previous).on('click', (event) => {
    previousStep()
    toggleActiveCards()
    showSkip(skip)
    checkStepIndex()
  })
  
  showSkip(skip)
  
  
  
  $body.on('click','.Product__quantity-btn', (event) => {
  //     debugger;
    var action = $(event.target).closest('button').attr('data-action');
    var $product_counter = $('.product-counter');
    var grid_action = $(event.target).closest('.grid-product__actions');
    var product =  $(event.target).closest('.grid-product');
    var qty_ele = $(event.target).closest('button').siblings('.Product__quantity-status');
    var qty = parseInt(qty_ele.text());
    var prodId = parseInt(product.attr('data-id'));
    
    
    if(action=="minus"){
      qty = qty - 1;
      if(qty<1){
        qty=0;
        product.removeClass('selected');
        grid_action.removeClass('active-qty');
      }
    }
    else if(action=="plus"){
      qty = qty + 1;
      if(!product.hasClass('selected')){product.addClass('selected');}
      if(!grid_action.hasClass('active-qty')) grid_action.addClass('active-qty');
      
    }
    product.attr('data-qty',qty);
    qty_ele.text(qty);
      // console.log(qty)
    handleSelection()
    populateStep(prodId,true)
    showPrice()
    setProductImages();  

    /*Qty restriction*/
    let activeStep = getActiveStep();
    let step_prod_limit = parseInt($(activeStep).attr('data-limit'));
    let jar_limit = parseInt($(activeStep).attr('data-jar-limit')) || 0 ;
    let getCurrentStepProducts = getCurrentStepSelectedCards();
    let qty_selected = getCurrentStepProducts.reduce((qty,b)=>qty+b.qty,0);
    $product_counter.find('.current-count').text(qty_selected);
    $product_counter.find('.max-count').text(step_prod_limit);
    let selectedProducts = $('.build-a-bundle-page .bundle-step-wrapper:visible .grid-product');
      // console.log(qty_selected,step_prod_limit)
    if(qty_selected>=step_prod_limit){
      $(selectedProducts).each((k, product) => {
        $(product).find('button.js-quick-add-bundle-item').attr('disabled','disabled');
        $(product).find('button.Product__quantity-btn[data-action="plus"]').attr('disabled','disabled');
      })
    }
    else{
  //       console.log('ehre')
      $(selectedProducts).each((k, product) => {
        $(product).find('button.js-quick-add-bundle-item').removeAttr('disabled');
        $(product).find('button.Product__quantity-btn[data-action="plus"]').removeAttr('disabled');
      })
    }
    /*Qty restriction ends*/
  });
  
  
  $("#js-filter-type").on('change',function(){
    var filter_selected = $(this).val(),
        current_step = $(this).closest('.bundle-step-wrapper'),
        product_grid = current_step.find('.product-grid');
    var filtered_prod = product_grid.find(`.grid-product[data-filter_tags*=${filter_selected}]`);
    var all_items = product_grid.find('.grid-product').not(filtered_prod);
    // console.log(filter_selected)
    if(filter_selected != 'All'){
      all_items.hide();
      filtered_prod.show();
    }
    else{
      product_grid.find('.grid-product').show();
    }
  });
  
  $("#js-price-sort").on('change',function(){
    var filter_selected = $(this).val();
        radioSort(filter_selected)  
  });

  $("#BlankCard").on('change',function(){
  var is_checked = $(this).prop('checked'),
  boxNote = $("#boxNote"),
  from_field = $("#from_field");
  if(is_checked){
  boxNote.val('');
  from_field.val('')
  }
  })
  
})